import {
  CssBaseline,
  AppBar,
  Toolbar,
  Typography,
  Grid,
  useTheme,
  useMediaQuery,
  Tabs,
  Tab,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { t } from "i18next";
import "./../../stylesheets/components/_Header.scss";
import Divider from "../Divider";
import CalendarIcon from "../Icons/CalendarIcon";
import ChatIcon from "../Icons/ChatIcon";
import PhoneIcon from "../Icons/PhoneIcon";
import { useEffect, useState } from "react";
import { BRAND_NAME, PHONE_NUMBER } from "../../utils/constants";

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up("sm"));

  const [tabValue, setTabValue] = useState<string | boolean>(location.pathname);

  const handleChange = (
    event: React.SyntheticEvent,
    newTabValue: string | boolean
  ) => {
    if (newTabValue === "call") {
      navigate("/");
      setTabValue(false);
    } else {
      setTabValue(newTabValue);
      navigate(String(newTabValue));
    }
  };

  useEffect(() => {
    if (location.pathname === "/") {
      setTabValue(false);
    }
  }, [location.pathname]);

  return (
    <>
      <CssBaseline />
      <AppBar sx={{ backgroundColor: "background.default" }} elevation={3}>
        <Divider />
        <Toolbar disableGutters={true}>
          <Grid
            container
            flexDirection={"row"}
            alignContent={"center"}
            justifyContent={"center"}
          >
            <Grid
              item
              container
              spacing={1}
              justifyContent={"center"}
              alignItems={"center"}
              xs={12}
              sm={6}
              onClick={() => {
                navigate("/");
              }}
              sx={{
                cursor: "pointer",
              }}
            >
              <Grid item>
                <img
                  className="logo-img"
                  src={"/logo.png"}
                  alt="Telstra logo"
                ></img>
              </Grid>
              <Grid item>
                <Typography color={"primary.dark"} fontWeight={"500"}>
                  |
                </Typography>
              </Grid>
              <Grid item>
                <Typography color={"primary.dark"} fontWeight={"500"}>
                  {BRAND_NAME}
                </Typography>
              </Grid>
            </Grid>
            {sm && (
              <Grid item xs={6}>
                <Tabs centered value={tabValue} onChange={handleChange}>
                  <Tab
                    label="Book a call back"
                    icon={<CalendarIcon />}
                    value={"/callback"}
                  />
                  <Tab label="Chat now" icon={<ChatIcon />} value={"/chat"} />
                  <Tab
                    label={t("footer.callNow", { phoneNumber: PHONE_NUMBER })}
                    value="call"
                    href={"tel:" + PHONE_NUMBER}
                    icon={<PhoneIcon />}
                  />
                </Tabs>
              </Grid>
            )}
          </Grid>
        </Toolbar>
      </AppBar>
      <Toolbar />
    </>
  );
}
